import { Action, createReducer, on } from '@ngrx/store';
import { MemberSummary, TopUpAccountStatus, Feature, ErrorModel, UserUpdateDetailsResponse } from '@classifieds-sell/datalayer';
import * as UserActions from './user.actions';

export const USER_FEATURE_KEY = 'user';

export interface UserState {
    memberSummary: MemberSummary;
    topUpAccountStatus: TopUpAccountStatus;
    features: Feature[];
    updateUserDetailsResponse: UserUpdateDetailsResponse;
    error?: ErrorModel | null;
}

export interface UserPartialState {
    readonly [USER_FEATURE_KEY]: UserState;
}

export const userInitialState: UserState = {
    memberSummary: null,
    topUpAccountStatus: null,
    features: null,
    updateUserDetailsResponse: null
};

const userReducer = createReducer(
    userInitialState,
    on(UserActions.getUserDetailsSuccess, (state, { userDetails }) => ({
        ...state,
        memberSummary: userDetails.memberSummary,
        topUpAccountStatus: userDetails.topUpAccountStatus,
        features: userDetails.features
    })),
    on(UserActions.getUserDetailsFailure, (state, { error }) => ({
        ...state,
        error
    })),
    on(UserActions.updateUserDetailsSuccess, (state, { userUpdated }) => ({
        ...state,
        updateUserDetailsResponse: { success: true, description: userUpdated}
    })),
    on(UserActions.updateUserDetailsFailure, (state, { error }) => ({
        ...state,
        updateUserDetailsResponse: {
            success: false,
            description: error?.message
        },
        error
    }))
);

export function userReducerFunc(state: UserState | undefined, action: Action) {
    return userReducer(state, action);
}
